<template>
  <nav class="navigation" :class="scrollDirection" v-on-click-outside="toggleNavigationOutside">
    <div class="navigation-background-illustration navigation-background-illustration--top" :style="'background-image: url(/app/images/objects/festive-decoration.svg);'"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-3 col-sm-2 col-6">
          <div class="navigation-brand">
            <router-link :to="{ path: getHome(data.settings.translatable, data.settings.locality) }">
              <img src="/app/images/logo/logo.svg" :alt="getSnippets('Company')" loading="lazy">
            </router-link>
          </div>
        </div>
        <div class="col-xl-9 col-sm-10 col-6">
          <div class="navigation-wrapper">
            <ul class="navigation-list">
              <li :class="{ 'full-menu': item.content && item.content.fullMenu === 'true' }" v-for="item in data.navigation.main" :key="item.id">
                <router-link :to="{ path: item.slug }">
                  {{ getTranslation(item, 'title') }}
                  <i class="fas fa-chevron-down" v-if="item.content.allowSubMenu"></i>
                </router-link>
                <div class="submenu" v-if="item.content && item.content.allowSubMenu === 'true'">
                  <div class="container">
                    <div class="sub-page" v-for="subPage in item.subMenu">
                      <router-link :to="{ path: subPage.slug }">
                        {{ getTranslation(subPage, 'title') }}
                      </router-link>
                      <div class="extra-submenu" v-if="subPage.content && subPage.content.allowSubMenu === 'true'">
                        <div class="extra-sub-page" v-for="extraSubPage in subPage.subMenu">
                          <router-link :to="{ path: extraSubPage.slug }">
                            {{ getTranslation(extraSubPage, 'title') }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="navigation-search">
              <a href="#" data-toggle="modal" data-target="#SearchModal">
                <i class="fas fa-search fa-fw"></i>
              </a>
            </div>
            <div class="navigation-toggle" @click="toggleNavigation">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navigation-content" :class="{ 'active': toggle }">
      <div class="navigation-content-background-illustration navigation-content-background-illustration--top" :style="'background-image: url(/app/images/objects/festive-decoration.svg);'"></div>
      <div class="navigation-header">
        <div class="navigation-title">
          {{ getSnippets('Menu') }}
        </div>
        <div class="navigation-toggle" @click="toggleNavigation">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <ul class="navigation-list">
        <li v-for="item in data.navigation.main" :key="item.id">
          <router-link :to="{ path: item.slug }">
            {{ getTranslation(item, 'title') }}
          </router-link>
        </li>
      </ul>
      <ul class="information-list">
        <li>
          <span class="company">{{ getSnippets('Company') }}</span>
          <span class="address" v-html="getSnippets('Company Address')"></span>
        </li>
        <li>
          <strong>Tel:</strong> <a :href="'tel:' + getSnippets('Company Phone')">{{ getSnippets('Company Phone') }}</a>
        </li>
        <li>
          <strong>Fax:</strong> {{ getSnippets('Company Fax') }}
        </li>
        <li>
          <strong>E-mail:</strong> <a :href="'mailto:' + getSnippets('Company Email')">{{ getSnippets('Company Email') }}</a>
        </li>
        <li>
          <strong>MB:</strong> {{ getSnippets('Company MB') }}
        </li>
        <li>
          <strong>OIB:</strong> {{ getSnippets('Company VAT') }}
        </li>
      </ul>
      <div class="navigation-content-background-illustration navigation-content-background-illustration--bottom" :style="'background-image: url(/app/images/objects/festive-decoration.svg);'"></div>
    </div>
    <div class="modal fade modal-search" id="SearchModal" tabindex="-1" role="dialog" aria-labelledby="SearchModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ getSnippets('Search')}}</h5>
            <a href="#" class="modal-close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>
          </div>
            <div class="modal-body">
              <form class="form" @submit.prevent="validateForm()">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    id="searchQuery"
                    :class="{ 'is-invalid': errors.has('searchQuery') }"
                    name="searchQuery"
                    v-model="searchQuery"
                    :placeholder="getSnippets('Query')"
                    v-validate="'required'"
                    @keyup="validateForm()"
                    data-vv-validate-on="change"
                    autocomplete="off">
                </div>
              </form>
              <div class="search-results" v-if="searchResults.length > 0 && searchQuery.length">
                <div class="loading" v-if="loading">
                  <Loading/>
                </div>
                <ul v-if="searchResults.length">
                  <li v-for="item in searchResults" :key="item.id">
                    <router-link :to="{ path: item.slug }">
                      {{ item.translations[data.settings.locality].title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Components */
import Loading from '@components/App/Partials/Loading';

/* Logic */
export default {
  name: 'Navigation',
  mixins: [Default],
  props: [
    'data'
  ],
  components: {
    Loading
  },
  data: function () {
    return {
      toggle: false,
      searchQuery: '',
      searchResults: [],
      loading: false,
      scrollPosition: 0,
      scrollDirection: "scroll-up",
    }
  },
  methods: {
    toggleNavigation: function () {
      this.toggle === true ? this.toggle = false : this.toggle = true;
    },
    toggleNavigationOutside: function () {
      this.toggle = false;
    },
    validateForm: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitForm();
        }
      });
    },
    submitForm: function () {
      this.loading = true;
      this.Axios.get('/api/v1/search', {
        params: {
          searchQuery: this.searchQuery,
          locality: this.data.settings.locality,
          translatable: this.data.settings.translatable
        }
      }).then(response => {
        this.status = response.data.content.status;
        this.message = response.data.content.message;
        this.searchResults = response.data.content.data;
      }).catch(() => {
        this.status = 'danger';
        this.message = this.getSnippets('Error');
      }).finally(() => {
        this.loading = false;
      })
    },
    handleScroll: function () {
      let currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

      if (window.pageYOffset === 0 || window.pageYOffset < 100) {
        this.scrollPosition = currentScrollPosition;
        this.scrollDirection = "scroll-up";
        return;
      }

      if (currentScrollPosition > 0 && this.scrollPosition <= currentScrollPosition) {
        this.scrollPosition = currentScrollPosition;
        this.scrollDirection = "scroll-down";
      } else {
        this.scrollPosition = currentScrollPosition;
        this.scrollDirection = "scroll-up";
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.navigation {
  position: relative;
  transition: $transition;
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.15);
  z-index: 1;

  // Tablet
  @include media-breakpoint-down(lg) {
    padding: 60px 0 24px;
  }

  // Mobile
  @include media-breakpoint-down(sm) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 38px 0 20px;
    background-color: $white;
  }

  &.scroll-up {
    // Mobile
    @include media-breakpoint-down(sm) {
      top: 0;
    }
  }

  &.scroll-down {
    // Mobile
    @include media-breakpoint-down(sm) {
      top: -100px;
    }
  }

  .col-sm-3,
  .col-sm-9,
  .col-6 {
    position: unset;
  }

  .navigation-brand {
    width: 230px;

    // Desktop
    @include media-breakpoint-down(xl) {
      width: 160px;
    }

    // Tablet
    @include media-breakpoint-down(lg) {
      width: 160px;
    }

    // Mobile
    @include media-breakpoint-down(sm) {
      width: 140px;
    }
  }

  .navigation-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .navigation-search {
      margin-left: 16px;

      // Small Tablet
      @include media-breakpoint-down(lg) {
        margin-left: 0;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        background: $grey-light-3;
        width: 36px;
        height: 36px;
        border-radius: 50px;
        color: $black;

        // Small Tablet
        @include media-breakpoint-down(lg) {
          font-size: 18px;
          background: $white;
        }

        &:hover {
          color: $color-1;
        }
      }
    }
  }

  .navigation-list {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: right;

    // Tablet
    @include media-breakpoint-down(lg) {
      display: none;
    }

    li {
      position: relative;
      display: inline-flex;
      padding: 40px 0;
      margin-left: 12px;

      // Tablet
      @include media-breakpoint-down(lg) {
        padding: 0;
      }

      &:hover {
        .submenu {
          display: flex;
        }
      }

      &.full-menu {
        position: unset;

        .submenu {
          padding: 32px 0;
          width: 100%;
          top: 135px;
          right: 0;
          left: 0;
          box-shadow: unset;

          .container {
            display: flex;
            justify-content: space-between;
          }

          .sub-page {
            max-width: 20%;

            a {
              display: inline-block;
              font-size: 16px;
              font-weight: 700;
              text-transform: uppercase;
              color: $black;
              border-bottom: 1px solid $black;
              padding: 0 0 4px;
              margin: 0;

              // Desktop
              @include media-breakpoint-down(xl) {
                font-size: 14px;
              }

              &:hover,
              &:active,
              &:focus,
              &:focus:active {
                color: $color-1;
              }
            }

            .extra-submenu {
              display: block;
              margin: 16px 0 0;
              padding: 0;

              .extra-sub-page {
                display: block;

                a {
                  display: inline-block;
                  padding: 0;
                  margin-bottom: 4px;
                  border-bottom: 0;
                  font-size: 14px;
                  font-weight: 400;
                  text-transform: unset;

                  &:hover,
                  &:active,
                  &:focus,
                  &:focus:active {
                    color: $color-1;
                  }
                }
              }
            }
          }
        }
      }

      a {
        position: relative;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;

        &:hover,
        &:active,
        &:focus,
        &:focus:active,
        &.router-link-exact-active {
          color: $color-1;

          &:after {
            width: 100%;
          }
        }

        &:after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 0;
          height: 2px;
          background-color: $color-1;
          transition: $transition;
        }

        i {
          position: absolute;
          bottom: -13px;
          left: calc(50% - 5px);
          font-size: 9px;
          opacity: 0.8;
          color: $black;
        }
      }

      .submenu {
        display: none;
        justify-content: space-around;
        position: absolute;
        top: 100px;
        right: 0;
        padding: 24px 0;
        background: $grey-light-2;
        text-align: left;
        z-index: 1;
        min-width: 240px;

        .sub-page {
          display: block;
          margin-left: 0;

          a {
            display: inline-block;
            text-transform: none;
            font-size: 14px;
            font-weight: 400;
            margin: 4px 0;
            color: $black;

            &:hover,
            &:active,
            &:focus,
            &:focus:active {
              color: $color-1;
            }

            &:after {
              height: 0;
            }
          }

          .extra-submenu {
            display: none;
          }
        }
      }
    }
  }

  .navigation-toggle {
    display: none;
    margin: 0 0 0 16px;
    width: 32px;

    // Small Tablet
    @include media-breakpoint-down(lg) {
      display: block;
    }

    span {
      position: relative;
      display: block;
      height: 2px;
      width: 32px;
      background-color: $black;
      margin: 4px 0;
      transition: $transition;
    }
  }

  .navigation-content {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 0;
    right: -100%;
    height: 100vh;
    width: 100%;
    padding: 60px 38px;
    background-color: $white;
    transition: $transition;
    z-index: 1;

    // Mobile
    @include media-breakpoint-down(sm) {
      padding: 40px 15px;
    }

    &.active {
      right: 0;
    }

    .navigation-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .navigation-title {
        font-size: 32px;
        font-weight: 700;
        text-transform: uppercase;
        color: $black;

        // Mobile
        @include media-breakpoint-down(sm) {
          font-size: 24px;
        }
      }

      .navigation-toggle {
        width: 28px;

        span {
          width: 28px;
          background-color: $black;
        }

        span:nth-child(1) {
          transform: rotate(45deg);
          top: 6px;
        }
        span:nth-child(2) {
          opacity: 0;
        }
        span:nth-child(3) {
          top: -5px;
          transform: rotate(-45deg);
        }
      }
    }

    .navigation-list {
      display: block;
      text-align: left;
      margin-top: 24px;

      li {
        display: block;
        margin-top: 4px;
        margin-bottom: 4px;
        margin-left: 0;

        a {
          font-size: 20px;
          color: $black;
        }
      }
    }

    .information-list {
      list-style: none;
      margin: 24px 0 0;
      padding: 24px 0 0;
      border-top: 1px solid $grey-light-2;
      color: $black;

      .company {
        display: block;
        font-weight: 600;
        margin-bottom: 4px;
      }

      .address {
        display: inline-block;
        margin-bottom: 12px;
      }

      strong {
        font-weight: 600;
      }
    }

    .navigation-content-background-illustration {
      position: absolute;
      right: 0;
      left: 0;
      width: 100%;
      height: 18px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      &--top {
        top: 0;
      }

      &--bottom {
        bottom: 0;
      }
    }
  }

  .navigation-background-illustration {
    width: 100%;
    height: 36px;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;

    // Tablet
    @include media-breakpoint-down(lg) {
      position: absolute;
      top: 0;
    }

    // Mobile
    @include media-breakpoint-down(sm) {
      height: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Navigation.vue